<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group mb-2">
                    <small class="input-title">Tel. Casa: </small>
                    <input type="text" class="form-control form-control-sm" v-model="data.phone" @keypress="NUMBER" :class="errors.phone ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.phone" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group mb-2">
                    <small class="input-title">Tel. Celular: </small>
                    <input type="text" class="form-control form-control-sm" v-model="data.mobil" @keypress="NUMBER" :class="errors.mobil ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.mobil" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="d-flex">
                    <div class="w-75">
                        <div class="form-group mb-2">
                            <small class="input-title">Tel. Trabajo: </small>
                            <input type="text" class="form-control form-control-sm" v-model="data.phone_work" @keypress="NUMBER" :class="errors.phone_work ? 'is-invalid' : ''">
                            <small class="invalid-feedback" v-for="(error, index) in errors.phone_work" :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="w-25 pl-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Ext.: </small>
                            <input type="text" class="form-control form-control-sm" v-model="data.phone_work_ext" @keypress="NUMBER" :class="errors.phone_work_ext ? 'is-invalid' : ''">
                            <small class="invalid-feedback" v-for="(error, index) in errors.phone_work_ext" :key="index">{{ error }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group mb-2">
                    <small class="input-title">Otro: </small>
                    <input type="text" class="form-control form-control-sm" v-model="data.phone_other" @keypress="NUMBER" :class="errors.phone_other ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.phone_other" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group mb-2">
                    <small class="input-title">Entregar en: </small>
                    <v-select v-model="data.deliver_to"
                        :items="delivers"
                        hide-details
                        @change="FRESH"
                        class="form-control form-control-sm"
                        :class="errors.branch ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.deliver_to" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-6" v-if="data.deliver_to == 1">
                <div class="form-group mb-2">
                    <small class="input-title">Sucursal: </small>
                    <v-select v-model="data.branch_office_id"
                        item-value="id"
                        item-text="name"
                        :items="branch_offices"
                        hide-details
                        class="form-control form-control-sm"
                        :class="errors.branch_office_id ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.branch_office_id" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-6" v-else>
                <div class="form-group mb-2">
                    <small class="input-title">Dirección: </small>
                    <input type="text" class="form-control form-control-sm" v-model="data.address" :class="errors.address ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.address" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="row" v-if="data.deliver_to == 0">
            <div class="col-lg-3">
                <div class="form-group mb-2">
                    <small class="input-title">País: </small>
                    <v-select v-model="data.country_id"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="PROVINCES"
                        class="form-control form-control-sm"
                        :class="errors.country_id ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.country_id" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group mb-2">
                    <small class="input-title">Provincia: </small>
                    <v-select v-model="data.province_id"
                        :items="provinces"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="CITIES"
                        class="form-control form-control-sm"
                        :class="errors.province_id ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.province_id" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group mb-2">
                    <small class="input-title">Cuidad: </small>
                    <v-select v-model="data.city_id"
                        :items="cities"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="DISTRICTS"
                        class="form-control form-control-sm"
                        :class="errors.city_id ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.city_id" :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group mb-2">
                    <small class="input-title">Distrito: </small>
                    <v-select v-model="data.district_id"
                        :items="districts"
                        item-text="name"
                        item-value="id"
                        hide-details
                        class="form-control form-control-sm"
                        :class="errors.district_id ? 'is-invalid' : ''">
                    </v-select>
                    <small class="invalid-feedback" v-for="(error, index) in errors.district_id" :key="index">{{ error }}</small>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'errors'],
    data(){
        return{
            delivers: [
                { value: 0, text: 'Dirección' },
                { value: 1, text: 'Sucursal' }
            ],
            countries: [],
            provinces: [],
            cities: [],
            districts: [],
            branch_offices: []
        }
    },
    created(){
        let vue = this
        if(vue.data.deliver_to == 0){
            vue.COUNTRIES()
        }else{
            if(vue.data.deliver_to == 1){
                vue.BRANCH_OFFICES()
            }
        }
    },
    methods: {
        FRESH: function(){
            let vue = this
            vue.data.country_id = ''
            vue.data.province_id = ''
            vue.data.city_id = ''
            vue.data.district_id = ''
            vue.data.address = ''
            vue.data.branch_office_id = ''
            if(vue.data.deliver_to == 1){
                vue.BRANCH_OFFICES()
            }else{
                vue.COUNTRIES()
            }
        },
        BRANCH_OFFICES: function(){
            let vue = this
            axios({url: '/all/branch-offices', method: 'GET' })
            .then((resp) => {
                vue.branch_offices = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        COUNTRIES: function(){
            let vue = this
            axios({url: '/locations/countries', method: 'GET' })
            .then((resp) => {
                vue.countries = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        PROVINCES: function(){
            let vue = this
            axios({url: '/locations/provinces/'+ vue.data.country_id, method: 'GET' })
            .then((resp) => {
                vue.provinces = resp.data
            })
            .finally((resp) => {
                if(vue.data.province_id){
                    vue.CITIES()
                }
            })
        },
        CITIES: function(){
            let vue = this
            axios({url: '/locations/cities/'+ vue.data.province_id, method: 'GET' })
            .then((resp) => {
                vue.cities = resp.data
            })
            .finally((resp) => {
                if(vue.data.city_id){
                    vue.DISTRICTS()
                }
            })
        },
        DISTRICTS: function(){
            let vue = this
            axios({url: '/locations/districts/'+ vue.data.city_id, method: 'GET' })
            .then((resp) => {
                vue.districts = resp.data
            })
        },
    },
    watch: {
        data: {
            handler(e) {
                let vue = this
                if(e.deliver_to == 0){
                    vue.COUNTRIES()
                }else{
                    if(e.deliver_to == 1){
                        vue.BRANCH_OFFICES()
                    }
                }
            },
            deep: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/users/forms/Contact.vue